import { useQuery } from '@apollo/client';
import {
  GET_DOCUMENT_TRACKING_HISTORY,
  GET_DOCUMENT_TRACKING_STATS,
} from '../graphql/documentTrackingOperations';

export interface DocumentTrackingLog {
  id: string;
  facturaId: number;
  numeroFactura: string;
  fechaCreacion: string;
  total: number;
  prefijo: string | null;
  esElectronica: boolean;
  clienteNombre: string | null;
  clienteDocumento: string | null;
  esConsumidorFinal: boolean;
  metodoPago: string | null;
  codigoDian: string | null;
  esSoloEfectivo: boolean;
  pagosMixtos: boolean;
  modActivo: boolean;
  forceElectronic: boolean;
  transmitida: boolean;
  tieneCufe: boolean;
  cufe: string | null;
  factusStatus: string | null;
  motivo: string;
  motivoCorto: string;
  categoriaDecision: string;
  sincronizadoAt: string;
}

export interface CategoriaCount {
  categoria: string;
  count: number;
  porcentaje: number;
}

export interface DocumentTrackingStats {
  totalDocumentos: number;
  transmitidas: number;
  noTransmitidas: number;
  porCategoria: CategoriaCount[];
}

export const useDocumentTrackingHistory = (date: string, pollInterval: number = 30000) => {
  const { data, loading, error, refetch } = useQuery(GET_DOCUMENT_TRACKING_HISTORY, {
    variables: { date },
    fetchPolicy: 'cache-and-network',
    pollInterval,
    skip: !date,
  });

  return {
    documents: (data?.getDocumentTrackingHistory || []) as DocumentTrackingLog[],
    loading,
    error,
    refetch,
  };
};

export const useDocumentTrackingStats = (date: string, pollInterval: number = 30000) => {
  const { data, loading, error } = useQuery(GET_DOCUMENT_TRACKING_STATS, {
    variables: { date },
    fetchPolicy: 'cache-and-network',
    pollInterval,
    skip: !date,
  });

  return {
    stats: data?.getDocumentTrackingStats as DocumentTrackingStats | undefined,
    loading,
    error,
  };
};
